/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
  */
 // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 //   $('.Header__CartDot').html(data.item_count);
 // }));

productSlider('.favourties_collection .ProductListWrapper .ProductList',true,2,2,false,true,false,1024,2, 767,1,1,false);
productSlider('.blog_post .ArticleListWrapper .ArticleList',true,3,2,false,true,true,1024,2, 767,1,1);
 productSlider('.anouncment_slider',true,1,1,false,true,true,1024,1,767,1,1);
function productSlider($sliderName,$dots,$slideslow,$slidescroll,$arrows,$autoplay,$infinite,$breakpoint,$ishow,$mbreakpoint,$msliders,$mscroll,$mautoplay){
 var slider =  $($sliderName);  
 return slider.slick({
            infinite: $infinite,
            slidesToShow: $slideslow,
            slidesToScroll: $slidescroll,
            arrows: $arrows,
            dots: $dots,
            autoplay: $autoplay,
             autoplaySpeed: 3000,
             speed: 1000,
            responsive: [
                {
                  breakpoint: $breakpoint,
                  settings: {
                    slidesToShow: $ishow,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: $mbreakpoint,
                  settings: {
                    slidesToShow: $msliders,
                    slidesToScroll:$mscroll,
                    autoplay: $mautoplay,
                    arrows: $arrows
                  }
                }
              ]
            } );
}  

 
// $(document).ready(function(){
//         $('.testi_slid').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         autoplay: true,
//         autoplayspeed:900,
//         dots:true,
//         infinite: true
    
//         });
//         });


$(document).ready(function() {
$(".background_video .ImageHero").click(function () {
    $(this).toggleClass("active");        
});
    });


$( "button.ProductForm__LabelLink.Link[aria-controls = bottom_modal]" ).prev("button[aria-controls = modal-]").css( "display", "none" );
// $( "button.ProductForm__LabelLink.Link[aria-controls = jacket_modal]" ).prev().css( "display", "none" );
$( "button.ProductForm__LabelLink.Link[aria-controls = Dupatta_modal]" ).prev("button[aria-controls = modal-]").css( "display", "none" );


$(document).ready(function() {
$("button.ProductForm__LabelLink.Link.Text--subdued").click(function () {
  // console.log("add");
    $(".Product.Product--large").addClass("z-index");        
});
  $(".Modal__Close").click(function () {
    $(".Product.Product--large").removeClass("z-index");        
});
});



// pop-up form js

// Get the modal
var modal = document.getElementById("measurment_guide_call");


// Get the button that opens the modal
var btn = document.getElementById("how_toM");
var ele = document.getElementById("modal-");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("closes")[0];
var modal_all = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
// btn.onclick = function() {
//   modal.style.display = "block";
// }
var element = document.getElementsByClassName('how_toM');
// element.addEventListener("click", myFunction);

// function myFunction() {
//    modal.style.display = "block";
//   ele.classList.add('open_modal');
  
// }
for (var i in element) {
  element[i].onclick = function() {
    modal.style.display = "block";
  };
}

 $(document).ready(function () {
        $('.close').click (function () {
             modal.style.display = "none";
        }
      )
    });


// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}
modal_all.onclick = function() {
  
   modal.style.display = "none";
};

// When the user clicks anywhere outside of the modal, close it
window.addEventListener("click", function(event) {
  var modal = document.getElementById('measurment_guide_call');
  // When the user clicks anywhere outside of the modal, close it
  if (event.target == modal) {
    // console.log(modal);
    modal.style.display = "none";
  }
});  
var body = document.getElementsByTagName("body")[0];
let removeClass = document.querySelectorAll("a.Modal__Close.RoundButton")[0];

removeClass.onclick = function() {
  body.classList.remove("has_modal_all");
}
// pop-up form js End

$("iframe#widget2").find("h1").remove();


